import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axiosInstance from "@common/utils/axiosInstance";
import apiUrl from "@common/utils/apiURL";

export default function JobDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axiosInstance.get(apiUrl.job.getById(id))
      .then((res) => setJob(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="bs-section">
        <div className="bs-section__section-cont cr-jd-page__loading">Loading…</div>
      </div>
    );
  }

  if (error || !job) {
    return (
      <div className="bs-section">
        <div className="bs-section__section-cont cr-jd-page__loading">Position not found.</div>
      </div>
    );
  }

  return (
    <div className="bs-section bs-section--typ-grey cr-jd-page">
      <div className="bs-section__section-cont">
        <motion.div
          className="cr-jd-page__inner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <button
            className="cr-jd-page__back"
            onClick={() => navigate("/careers")}
            type="button"
          >
            <ArrowBackIcon className="cr-jd-page__back-icon" />
            All Positions
          </button>

          <div className="cr-jd-modal__header">
            <span className="cr-jd-modal__dept-badge">{job.category}</span>
            <h1 className="cr-jd-modal__title">{job.title}</h1>
            <div className="cr-jd-modal__meta">
              <span className="cr-jd-modal__meta-item">
                <PlaceOutlinedIcon className="cr-jd-modal__meta-icon" />
                {job.location}
              </span>
              <span className="cr-jd-modal__meta-item">
                <WorkOutlineOutlinedIcon className="cr-jd-modal__meta-icon" />
                {job.type}
              </span>
            </div>
          </div>

          <div className="cr-jd-modal__body">
            {job.companyOutline && (
              <div className="cr-jd-modal__section">
                <h3 className="cr-jd-modal__section-title">About the Company</h3>
                <p className="cr-jd-modal__outline">
                  {job.companyOutline.split(/\r?\n/).map((line, i, arr) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < arr.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            )}

            {job.jd?.description && (
              <>
                <h3 className="cr-jd-modal__section-title">descriptions</h3>
                <p className="cr-jd-modal__summary">
                  {job.jd.description.split(/\r?\n/).map((line, i, arr) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < arr.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </>
            )}

            {job.jd?.responsibilities?.length > 0 && (
              <div className="cr-jd-modal__section">
                <h3 className="cr-jd-modal__section-title">Job Description / Desired Profile:</h3>
                <ul className="cr-jd-modal__list">
                  {job.jd.responsibilities.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {job.jd?.requirements?.length > 0 && (
              <div className="cr-jd-modal__section">
                <h3 className="cr-jd-modal__section-title">Total experience and Skills required:</h3>
                <ul className="cr-jd-modal__list">
                  {job.jd.requirements.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {job.jd?.education?.length > 0 && (
              <div className="cr-jd-modal__section">
                <h3 className="cr-jd-modal__section-title">Education</h3>
                <ul className="cr-jd-modal__list">
                  {job.jd.education.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {job.jd?.benefits?.length > 0 && (
              <div className="cr-jd-modal__section">
                <h3 className="cr-jd-modal__section-title">What We Offer</h3>
                <div className="cr-jd-modal__benefits">
                  {job.jd.benefits.map((item, i) => (
                    <span key={i} className="cr-jd-modal__benefit-tag">{item}</span>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="cr-jd-modal__footer">
            <a
              href={`mailto:careers@sansaar.co.in?subject=Application for ${job.title}&body=Hi, I would like to apply for the ${job.title} position.`}
              className="bs-btn bs-btn__btn-solid cr-jd-modal__apply-btn"
            >
              Apply for this Role
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
